// Imports
import axios from "axios";
import "../../../setup/config/apiConfig";

export const RESET = "RESET";
export const GET_VENDORS = "GET_VENDORS";
export const GET_VENDORS_RESPONSE = "GET_VENDORS_RESPONSE";
export const GET_VENDORS_RESPONSE_FAIL = "GET_VENDORS_RESPONSE_FAIL";
export const GET_VENDOR = "GET_VENDOR";
export const GET_VENDOR_RESPONSE = "GET_VENDOR_RESPONSE";
export const GET_VENDOR_RESPONSE_FAIL = "GET_VENDOR_RESPONSE_FAIL";

export const CREATE_VENDOR = "CREATE_VENDOR";
export const CREATE_VENDOR_RESPONSE = "CREATE_VENDOR_RESPONSE";
export const CREATE_VENDOR_RESPONSE_FAIL = "CREATE_VENDOR_RESPONSE_FAIL";
export const UPDATE_VENDOR = "UPDATE_VENDOR";
export const UPDATE_VENDOR_RESPONSE = "UPDATE_VENDOR_RESPONSE";
export const UPDATE_VENDOR_RESPONSE_FAIL = "UPDATE_VENDOR_RESPONSE_FAIL";

// Vendor rider rate action types (mirrors property rider rate actions)
export const GET_VENDOR_RIDER_RATE_REQUEST = "GET_VENDOR_RIDER_RATE_REQUEST";
export const GET_VENDOR_RIDER_RATE_RESPONSE = "GET_VENDOR_RIDER_RATE_RESPONSE";
export const GET_VENDOR_RIDER_RATE_FAIL = "GET_VENDOR_RIDER_RATE_FAIL";
export const UPDATE_LOCAL_VENDOR_RIDER_RATES = "UPDATE_LOCAL_VENDOR_RIDER_RATES";
export const CREATE_VENDOR_RIDER_RATE_REQUEST = "CREATE_VENDOR_RIDER_RATE_REQUEST";
export const CREATE_VENDOR_RIDER_RATE_RESPONSE = "CREATE_VENDOR_RIDER_RATE_RESPONSE";
export const UPDATE_VENDOR_RIDER_RATE_REQUEST = "UPDATE_VENDOR_RIDER_RATE_REQUEST";
export const UPDATE_VENDOR_RIDER_RATE_RESPONSE = "UPDATE_VENDOR_RIDER_RATE_RESPONSE";
export const DELETE_VENDOR_RIDER_RATE_REQUEST = "DELETE_VENDOR_RIDER_RATE_REQUEST";
export const DELETE_VENDOR_RIDER_RATE_RESPONSE = "DELETE_VENDOR_RIDER_RATE_RESPONSE";

export const GET_VENDOR_BASE_CHARGE_REQUEST = "GET_VENDOR_BASE_CHARGE_REQUEST";
export const GET_VENDOR_BASE_CHARGE_RESPONSE = "GET_VENDOR_BASE_CHARGE_RESPONSE";
export const GET_VENDOR_BASE_CHARGE_FAIL = "GET_VENDOR_BASE_CHARGE_FAIL";
export const UPDATE_LOCAL_VENDOR_BASE_CHARGES = "UPDATE_LOCAL_VENDOR_BASE_CHARGES";
export const CREATE_VENDOR_BASE_CHARGE_REQUEST = "CREATE_VENDOR_BASE_CHARGE_REQUEST";
export const CREATE_VENDOR_BASE_CHARGE_RESPONSE = "CREATE_VENDOR_BASE_CHARGE_RESPONSE";
export const UPDATE_VENDOR_BASE_CHARGE_REQUEST = "UPDATE_VENDOR_BASE_CHARGE_REQUEST";
export const UPDATE_VENDOR_BASE_CHARGE_RESPONSE = "UPDATE_VENDOR_BASE_CHARGE_RESPONSE";
export const DELETE_VENDOR_BASE_CHARGE_REQUEST = "DELETE_VENDOR_BASE_CHARGE_REQUEST";
export const DELETE_VENDOR_BASE_CHARGE_RESPONSE = "DELETE_VENDOR_BASE_CHARGE_RESPONSE";

export const GET_VENDOR_PROPERTIES_REQUEST = "GET_VENDOR_PROPERTIES_REQUEST";
export const GET_VENDOR_PROPERTIES_RESPONSE = "GET_VENDOR_PROPERTIES_RESPONSE";
export const GET_VENDOR_PROPERTIES_FAIL = "GET_VENDOR_PROPERTIES_FAIL";

export function get(isLoading = true) {
  return (dispatch) => {
    dispatch({
      type: GET_VENDORS,
      isLoading: isLoading,
    });
    return axios
      .get(`/vendor`)
      .then((response) => {
        dispatch({
          type: GET_VENDORS_RESPONSE,
          vendors: response.data,
        });
        return response.data;
      })
      .catch((error) => {
        dispatch({
          type: GET_VENDORS_RESPONSE_FAIL,
          isLoading: false,
          error: error,
        });
        throw error;
      });
  };
}

export function getByUuid(uuid, isLoading = true) {
  return (dispatch) => {
    dispatch({
      type: GET_VENDOR,
      isLoading: isLoading,
    });
    return axios
      .get(`/vendor/${uuid}`)
      .then((response) => {
        dispatch({
          type: GET_VENDOR_RESPONSE,
          vendor: response.data,
        });
        return response.data;
      })
      .catch((error) => {
        dispatch({
          type: GET_VENDOR_RESPONSE_FAIL,
          isLoading: false,
          error: error,
        });
        throw error;
      });
  };
}

export function getById(id, isLoading = true) {
  return (dispatch) => {
    dispatch({
      type: GET_VENDOR,
      isLoading: isLoading,
    });
    return axios
      .get(`/vendor/${id}`)
      .then((response) => {
        dispatch({
          type: GET_VENDOR_RESPONSE,
          vendor: response.data,
        });
        return response.data;
      })
      .catch((error) => {
        dispatch({
          type: GET_VENDOR_RESPONSE_FAIL,
          isLoading: false,
          error: error,
        });
        throw error;
      });
  };
}

export function createVendor(vendor, isLoading = true) {
  return (dispatch) => {
    dispatch({
      type: CREATE_VENDOR,
      isLoading: isLoading,
    });

    return axios
      .post(`/vendor`, vendor)
      .then((response) => {
        dispatch({
          type: CREATE_VENDOR_RESPONSE,
          vendor: response.data,
        });
        return response.data;
      })
      .catch((error) => {
        dispatch({
          type: CREATE_VENDOR_RESPONSE_FAIL,
          isLoading: false,
          error: error,
        });
        throw error;
      });
  };
}

export function updateVendor(uuid, vendor, isLoading = true) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_VENDOR,
      isLoading: isLoading,
    });

    return axios
      .put(`/vendor/${uuid}`, vendor)
      .then((response) => {
        dispatch({
          type: UPDATE_VENDOR_RESPONSE,
          vendor: response.data,
        });
        return response.data;
      })
      .catch((error) => {
        dispatch({
          type: UPDATE_VENDOR_RESPONSE_FAIL,
          isLoading: false,
          error: error,
        });
        throw error;
      });
  };
}

/*
=============================================================================
  Vendor Rider Rates
=============================================================================
  Vendor-scoped rider rate CRUD, mirroring the property rider rate actions:
    - GET    /utilityriderrate/vendor/:uuid
    - POST   /createutilityriderrate/vendor/     { vendorUuid, utilityRiderRates }
    - POST   /deleteutilityriderrate/vendor/     { vendorUuid, utilityRiderRateUUID }
    - PUT    /utilityriderrate/:uuid             (entity-level)
=============================================================================
*/

export function updateLocalVendorRiderRates(newRiderRates) {
  return { type: UPDATE_LOCAL_VENDOR_RIDER_RATES, newRiderRates };
}

export function getVendorRiderRatesByVendorUuid(uuid, isLoading = true) {
  return (dispatch) => {
    dispatch({
      type: GET_VENDOR_RIDER_RATE_REQUEST,
      isLoading: isLoading,
    });
    return axios
      .get(`/utilityriderrate/vendor/${uuid}`)
      .then((response) => {
        dispatch({
          type: GET_VENDOR_RIDER_RATE_RESPONSE,
          vendorRiderRates: response.data,
        });
        return response.data;
      })
      .catch((error) => {
        dispatch({
          type: GET_VENDOR_RIDER_RATE_FAIL,
          isLoading: false,
          error: error,
        });
      });
  };
}

export function createVendorRiderRate(riderRates, vendorUuid) {
  return (dispatch) => {
    dispatch({ type: CREATE_VENDOR_RIDER_RATE_REQUEST });
    const payload = { vendorUuid: vendorUuid, utilityRiderRates: riderRates };
    return axios
      .post("/createutilityriderrate/vendor/", payload)
      .then((response) => {
        let error = "";
        if (response.data.errors && response.data.errors.length > 0) {
          error = response.data.errors[0].message;
        }
        dispatch({
          type: CREATE_VENDOR_RIDER_RATE_RESPONSE,
          newData: response.data,
          error: error,
        });
        return response.data;
      })
      .catch((error) => {
        dispatch({
          type: CREATE_VENDOR_RIDER_RATE_RESPONSE,
          error: error,
        });
      });
  };
}

export function updateVendorRiderRate(riderRate) {
  return (dispatch) => {
    dispatch({ type: UPDATE_VENDOR_RIDER_RATE_REQUEST });
    return axios
      .put("/utilityriderrate/" + riderRate.uuid, riderRate)
      .then((response) => {
        let error = "";
        if (response.data.errors && response.data.errors.length > 0) {
          error = response.data.errors[0].message;
        }
        dispatch({ type: UPDATE_VENDOR_RIDER_RATE_RESPONSE, error: error });
        return response.data;
      })
      .catch((error) => {
        dispatch({ type: UPDATE_VENDOR_RIDER_RATE_RESPONSE, error: error });
      });
  };
}

export function deleteVendorRiderRate(riderRateUUID, vendorUuid) {
  return (dispatch) => {
    dispatch({ type: DELETE_VENDOR_RIDER_RATE_REQUEST });
    const payload = { vendorUuid: vendorUuid, utilityRiderRateUUID: riderRateUUID };
    return axios
      .post("/deleteutilityriderrate/vendor/", payload)
      .then((response) => {
        let error = "";
        if (response.data.errors && response.data.errors.length > 0) {
          error = response.data.errors[0].message;
        }
        dispatch({ type: DELETE_VENDOR_RIDER_RATE_RESPONSE, error: error });
        return response.data;
      })
      .catch((error) => {
        dispatch({ type: DELETE_VENDOR_RIDER_RATE_RESPONSE, error: error });
      });
  };
}

export function updateLocalVendorBaseCharges(newBaseCharges) {
  return { type: UPDATE_LOCAL_VENDOR_BASE_CHARGES, newBaseCharges };
}

export function getVendorBaseChargesByVendorUuid(uuid, isLoading = true) {
  return (dispatch) => {
    dispatch({
      type: GET_VENDOR_BASE_CHARGE_REQUEST,
      isLoading: isLoading,
    });
    return axios
      .get(`/vendorbasecharge/vendor/${uuid}`)
      .then((response) => {
        dispatch({
          type: GET_VENDOR_BASE_CHARGE_RESPONSE,
          vendorBaseCharges: response.data,
        });
        return response.data;
      })
      .catch((error) => {
        dispatch({
          type: GET_VENDOR_BASE_CHARGE_FAIL,
          isLoading: false,
          error: error,
        });
      });
  };
}

export function createVendorBaseCharge(baseCharge, vendorUuid) {
  return (dispatch) => {
    dispatch({ type: CREATE_VENDOR_BASE_CHARGE_REQUEST });
    const payload = { vendorUuid, ...baseCharge };
    return axios
      .post("/vendorbasecharge/vendor/", payload)
      .then((response) => {
        dispatch({
          type: CREATE_VENDOR_BASE_CHARGE_RESPONSE,
          newData: response.data,
        });
        return response.data;
      })
      .catch((error) => {
        dispatch({
          type: CREATE_VENDOR_BASE_CHARGE_RESPONSE,
          error: error,
        });
        throw error;
      });
  };
}

export function updateVendorBaseCharge(baseCharge) {
  return (dispatch) => {
    const { uuid, vendorUuid, vendorId, valid, created, updated, ...body } = baseCharge;
    dispatch({ type: UPDATE_VENDOR_BASE_CHARGE_REQUEST });
    return axios
      .put(`/vendorbasecharge/${uuid}`, body)
      .then((response) => {
        dispatch({ type: UPDATE_VENDOR_BASE_CHARGE_RESPONSE });
        return response.data;
      })
      .catch((error) => {
        dispatch({ type: UPDATE_VENDOR_BASE_CHARGE_RESPONSE, error: error });
        throw error;
      });
  };
}

export function deleteVendorBaseCharge(baseChargeUuid) {
  return (dispatch) => {
    dispatch({ type: DELETE_VENDOR_BASE_CHARGE_REQUEST });
    return axios
      .delete(`/vendorbasecharge/${baseChargeUuid}`)
      .then((response) => {
        dispatch({ type: DELETE_VENDOR_BASE_CHARGE_RESPONSE });
        return response.data;
      })
      .catch((error) => {
        dispatch({ type: DELETE_VENDOR_BASE_CHARGE_RESPONSE, error: error });
        throw error;
      });
  };
}

export function getPropertiesByVendorUuid(vendorUuid, isLoading = true) {
  return (dispatch) => {
    dispatch({
      type: GET_VENDOR_PROPERTIES_REQUEST,
      isLoading: isLoading,
    });
    return axios
      .get(`/property/vendor/${vendorUuid}`)
      .then((response) => {
        dispatch({
          type: GET_VENDOR_PROPERTIES_RESPONSE,
          vendorProperties: response.data,
        });
        return response.data;
      })
      .catch((error) => {
        dispatch({
          type: GET_VENDOR_PROPERTIES_FAIL,
          isLoading: false,
          error: error,
        });
        throw error;
      });
  };
}